module.exports = __webpack_public_path__ + "img/course.09491c56.jpg";